
import utils from "../../../utils/utils.js";
export default {
    async fetchFeedDetail(context, payload) {
        const feedId = payload.docId;
        const languageId = payload.languageId;

        const response = await utils.utility.fetch(`api/Editor/GetFeedDetails?feedId=${feedId}&multiLanguage=${languageId}`,
             "GET", null, null);

        context.commit("setFeedDetail", response.data);
    }
}